import { useState, useEffect } from "react";
import Navbar from "./Navbar";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Footer from "./Footer.jsx";
import PaymentReceipt from "./PaymentReceipt";

// API Base URL - Use LOCAL for testing
//const API_BASE_URL = 'http://localhost/royaleheritagefiesta/api';
const API_BASE_URL = 'https://royaleheritagefiesta.com/royaleheritagefiesta/api';

function Booking_event() {
  const location = useLocation();
  const eventId = location.state?.eventId;

  const [stalls, setStalls] = useState([]);
  const [selectedStall, setSelectedStall] = useState(null);
  const [hoveredStall, setHoveredStall] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(true);
  const [paymentProcessing, setPaymentProcessing] = useState(false);
  const [error, setError] = useState(null);
  const [event, setEvent] = useState(null);
  const [stallPattern, setStallPattern] = useState("full");
  const [stats, setStats] = useState({
    totalStalls: 0,
    bookedCount: 0,
    availableCount: 0
  });
  
  // Receipt state
  const [showReceipt, setShowReceipt] = useState(false);
  const [receiptData, setReceiptData] = useState(null);
  
  const [isCustomLayout, setIsCustomLayout] = useState(false);
  const [customStalls, setCustomStalls] = useState([]);
  const [fixedElements, setFixedElements] = useState([]);
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [imageDimensions, setImageDimensions] = useState({ width: 800, height: 1100 });
  const [gridSize, setGridSize] = useState(40);
  const [showBlueprint, setShowBlueprint] = useState(true);
  const [imageOpacity, setImageOpacity] = useState(0.8);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [showFloatingButtons, setShowFloatingButtons] = useState(false);
  
  // Zoom state for mobile
  const [zoomLevel, setZoomLevel] = useState(1);

  const [customer, setCustomer] = useState({
    name: "",
    phone: "",
    email: "",
    company: "",
    requirements: ""
  });

  // Scroll listener for floating buttons
  useEffect(() => {
    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 300);
      setShowFloatingButtons(window.scrollY > 500);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleBackToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/918688365247?text=Hi%20Royal%20Heritage%20Festia%20team,%20I%27m%20interested%20in%20booking%20a%20stall.', '_blank');
  };

  // Zoom functions for mobile
  const handleZoomIn = () => {
    if (zoomLevel < 2) {
      setZoomLevel(prev => Math.min(2, prev + 0.1));
    }
  };

  const handleZoomOut = () => {
    if (zoomLevel > 0.5) {
      setZoomLevel(prev => Math.max(0.5, prev - 0.1));
    }
  };

  const handleResetZoom = () => {
    setZoomLevel(1);
  };

  // Helper function to get total stalls by pattern
  const getTotalStallsByPattern = (pattern) => {
    switch(pattern) {
      case "full": return 50;
      case "ushape": return 50;
      case "twosides": return 50;
      default: return 50;
    }
  };

  // Send WhatsApp confirmation to admin after successful booking
  const sendAdminWhatsAppConfirmation = async (bookingDetails, paymentDetails, customerDetails) => {
    try {
      const message = `*🎉 NEW STALL BOOKING CONFIRMED!*%0A%0A` +
        `*Booking ID:* ${bookingDetails.bookingId}%0A` +
        `*Payment ID:* ${paymentDetails.paymentId}%0A` +
        `*Order ID:* ${paymentDetails.orderId}%0A%0A` +
        `*📋 EVENT DETAILS*%0A` +
        `*Event:* ${bookingDetails.eventName}%0A` +
        `*Date:* ${bookingDetails.eventDate || 'N/A'}%0A` +
        `*Venue:* ${bookingDetails.eventPlace || 'N/A'}%0A%0A` +
        `*🪑 STALL DETAILS*%0A` +
        `*Stall Number:* ${bookingDetails.stallNumber}%0A` +
        `*Amount Paid:* ₹${bookingDetails.amount}%0A` +
        `*Booking Time:* ${bookingDetails.bookingTime}%0A%0A` +
        `*👤 CUSTOMER DETAILS*%0A` +
        `*Name:* ${customerDetails.name}%0A` +
        `*Phone:* ${customerDetails.phone}%0A` +
        `*Email:* ${customerDetails.email}%0A` +
        `*Company:* ${customerDetails.company || 'N/A'}%0A` +
        `*Requirements:* ${customerDetails.requirements || 'N/A'}%0A%0A` +
        `*✅ Booking Status:* CONFIRMED%0A` +
        `*💰 Payment Status:* PAID%0A%0A` +
        `_Message sent from Royal Heritage Fiesta Booking System_`;

      const adminPhone = "919966252374";
      const whatsappLink = `https://wa.me/${adminPhone}?text=${message}`;
      
      window.open(whatsappLink, '_blank');
      
      console.log("Admin WhatsApp notification sent");
    } catch (error) {
      console.error("Error sending admin WhatsApp:", error);
    }
  };

  // Send booking confirmation emails to BOTH customer and admin
  const sendBookingEmails = async (bookingDetails, paymentDetails, customerDetails, eventDetails) => {
    try {
      console.log("Sending booking confirmation emails...");
      
      const emailData = {
        bookingData: {
          bookingId: bookingDetails.bookingId,
          stallNumber: bookingDetails.stallNumber,
          amount: bookingDetails.amount,
          bookingTime: bookingDetails.bookingTime
        },
        paymentData: {
          paymentId: paymentDetails.paymentId,
          orderId: paymentDetails.orderId
        },
        customerData: {
          name: customerDetails.name,
          phone: customerDetails.phone,
          email: customerDetails.email,
          company: customerDetails.company || "",
          requirements: customerDetails.requirements || ""
        },
        eventData: {
          eventName: eventDetails.eventName || "",
          eventDate: eventDetails.eventDate || "",
          eventPlace: eventDetails.eventPlace || ""
        }
      };
      
      // Send email to customer
      if (customerDetails.email && customerDetails.email.includes('@')) {
        console.log("Sending email to customer:", customerDetails.email);
        const customerResponse = await axios.post(`${API_BASE_URL}/send-mail.php`, {
          ...emailData,
          to: customerDetails.email,
          recipientType: 'customer'
        }, {
          headers: { 'Content-Type': 'application/json' },
          timeout: 30000
        });
        
        if (customerResponse.data && customerResponse.data.success) {
          console.log("✅ Booking confirmation sent to customer:", customerDetails.email);
        } else {
          console.error("❌ Failed to send email to customer:", customerResponse.data?.error);
        }
      } else {
        console.warn("No valid customer email provided");
      }
      
      // Send email to admin
      console.log("Sending email to admin: yugandharrada007@gmail.com");
      const adminResponse = await axios.post(`${API_BASE_URL}/send-mail.php`, {
        ...emailData,
        to: 'royaleheritagefiesta@gmail.com',
        recipientType: 'admin'
      }, {
        headers: { 'Content-Type': 'application/json' },
        timeout: 30000
      });
      
      if (adminResponse.data && adminResponse.data.success) {
        console.log("✅ Booking confirmation sent to admin");
      } else {
        console.error("❌ Failed to send email to admin:", adminResponse.data?.error);
      }
      
    } catch (error) {
      console.error("❌ Error sending emails:", error.message);
      if (error.response) {
        console.error("Server response:", error.response.data);
      }
      // Don't block the booking flow
    }
  };

  // Fetch event details and stalls
  useEffect(() => {
    if (!eventId) {
      setError("No event selected!");
      setLoading(false);
      return;
    }
    
    const fetchData = async () => {
      try {
        setLoading(true);
        
        const eventRes = await axios.get(`${API_BASE_URL}/events.php?eventId=${eventId}`);
        console.log("Event details received:", eventRes.data);
        
        const eventData = eventRes.data;
        setEvent(eventData);
        setStallPattern(eventData.stallPattern || "full");
        
        const hasCustomLayout = eventData.isCustomLayout === true || eventData.stallPattern === "custom";
        setIsCustomLayout(hasCustomLayout);
        
        // Fetch booked stalls from database
        let bookedStallsMap = {};
        try {
          const bookedRes = await axios.get(`${API_BASE_URL}/stall-bookings.php?eventId=${eventId}`);
          console.log("Booked stalls response:", bookedRes.data);
          
          if (bookedRes.data.success && bookedRes.data.bookings) {
            bookedRes.data.bookings.forEach(booking => {
              bookedStallsMap[booking.stallNumber] = true;
            });
          } else if (Array.isArray(bookedRes.data)) {
            bookedRes.data.forEach(booking => {
              bookedStallsMap[booking.stallNumber] = true;
            });
          }
        } catch (dbError) {
          console.log("Could not fetch booked stalls:", dbError);
        }
        
        if (hasCustomLayout && eventData.customLayoutData) {
          try {
            const layoutData = typeof eventData.customLayoutData === 'string' 
              ? JSON.parse(eventData.customLayoutData) 
              : eventData.customLayoutData;
            
            const stallsFromLayout = layoutData.stalls || [];
            const updatedStalls = stallsFromLayout.map(stall => ({
              ...stall,
              booked: bookedStallsMap[stall.number] === true || false
            }));
            
            setCustomStalls(updatedStalls);
            setFixedElements(layoutData.fixedElements || []);
            setBackgroundImage(layoutData.backgroundImage || eventData.blueprintImage || null);
            
            if (layoutData.imageDimensions) {
              setImageDimensions(layoutData.imageDimensions);
            }
            if (layoutData.gridSize) {
              setGridSize(layoutData.gridSize);
            }
            
            const bookedCount = updatedStalls.filter(s => s.booked).length;
            setStats({
              totalStalls: updatedStalls.length,
              bookedCount: bookedCount,
              availableCount: updatedStalls.length - bookedCount
            });
            
          } catch (e) {
            console.error("Error parsing custom layout data:", e);
            setCustomStalls([]);
            setStats({ totalStalls: 0, bookedCount: 0, availableCount: 0 });
          }
        } else {
          const totalStallsCount = getTotalStallsByPattern(stallPattern);
          const generatedStalls = [];
          
          for (let i = 1; i <= totalStallsCount; i++) {
            generatedStalls.push({
              stallId: i,
              price: eventData.stallPrice || 8000,
              booked: bookedStallsMap[i] === true
            });
          }
          
          setStalls(generatedStalls);
          
          const bookedCount = generatedStalls.filter(s => s.booked).length;
          setStats({
            totalStalls: totalStallsCount,
            bookedCount: bookedCount,
            availableCount: totalStallsCount - bookedCount
          });
        }
        
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Error loading stalls. Please refresh the page.");
        setLoading(false);
      }
    };

    fetchData();
  }, [eventId]);

  const getStallsByPosition = () => {
    const sortedStalls = [...stalls].sort((a, b) => a.stallId - b.stallId);
    
    const positions = {
      top: [], bottom: [], left: [], right: [], leftInner: [], rightInner: []
    };

    switch(stallPattern) {
      case "full":
        positions.top = sortedStalls.filter(s => s.stallId >= 1 && s.stallId <= 12);
        positions.left = sortedStalls.filter(s => s.stallId >= 13 && s.stallId <= 24);
        positions.right = sortedStalls.filter(s => s.stallId >= 25 && s.stallId <= 36);
        positions.bottom = sortedStalls.filter(s => s.stallId >= 37 && s.stallId <= 50);
        break;
      case "ushape":
        positions.left = sortedStalls.filter(s => s.stallId >= 1 && s.stallId <= 12);
        positions.right = sortedStalls.filter(s => s.stallId >= 13 && s.stallId <= 24);
        positions.bottom = sortedStalls.filter(s => s.stallId >= 25 && s.stallId <= 38);
        positions.leftInner = sortedStalls.filter(s => s.stallId >= 39 && s.stallId <= 44);
        positions.rightInner = sortedStalls.filter(s => s.stallId >= 45 && s.stallId <= 50);
        break;
      case "twosides":
        positions.left = sortedStalls.filter(s => s.stallId >= 1 && s.stallId <= 25);
        positions.right = sortedStalls.filter(s => s.stallId >= 26 && s.stallId <= 50);
        break;
      default:
        positions.top = sortedStalls.filter(s => s.stallId >= 1 && s.stallId <= 12);
        positions.left = sortedStalls.filter(s => s.stallId >= 13 && s.stallId <= 24);
        positions.right = sortedStalls.filter(s => s.stallId >= 25 && s.stallId <= 36);
        positions.bottom = sortedStalls.filter(s => s.stallId >= 37 && s.stallId <= 50);
    }
    return positions;
  };

  const handleStallClick = (stall) => {
    if (stall.booked) {
      alert("This stall is already booked!");
      return;
    }
    setSelectedStall(stall);
    setShowPopup(true);
  };

  const handleCustomStallClick = (stall) => {
    if (stall.booked) {
      alert("This stall is already booked!");
      return;
    }
    setSelectedStall({
      stallId: stall.number,
      price: stall.price,
      ...stall
    });
    setShowPopup(true);
  };

  // WhatsApp Assistance - Send customer details to admin WhatsApp
  const handleWhatsAppAssistance = () => {
    if (!customer.name || !customer.phone || !customer.email) {
      alert("Please fill all required fields");
      return;
    }

    if (customer.phone.length !== 10) {
      alert("Please enter a valid 10-digit phone number");
      return;
    }

    const message = `*NEW STALL BOOKING ASSISTANCE REQUEST*%0A%0A` +
      `*Event:* ${event?.eventName || 'Event'}%0A` +
      `*Stall Number:* ${selectedStall?.stallId || selectedStall?.number}%0A` +
      `*Stall Price:* ₹${selectedStall?.price || 8000}%0A%0A` +
      `*CUSTOMER DETAILS*%0A` +
      `*Name:* ${customer.name}%0A` +
      `*Phone:* ${customer.phone}%0A` +
      `*Email:* ${customer.email}%0A` +
      `*Company:* ${customer.company || 'Not provided'}%0A` +
      `*Requirements:* ${customer.requirements || 'Not provided'}%0A%0A` +
      `*Request Time:* ${new Date().toLocaleString()}%0A%0A` +
      `Customer needs assistance with booking. Please contact them.`;

    const phoneNumber = "919966252374";
    const whatsappLink = `https://wa.me/${phoneNumber}?text=${message}`;
    
    window.open(whatsappLink, '_blank');
    setShowPopup(false);
    setCustomer({
      name: "",
      phone: "",
      email: "",
      company: "",
      requirements: ""
    });
    setSelectedStall(null);
  };

  // Load Razorpay script
  const loadRazorpayScript = () => {
    return new Promise((resolve) => {
      if (window.Razorpay) {
        resolve(true);
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://checkout.razorpay.com/v1/checkout.js';
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  // Proceed to Payment
const handleProceedToPay = async () => {
  if (!customer.name || !customer.phone || !customer.email) {
    alert("Please fill all required fields");
    return;
  }

  if (customer.phone.length !== 10) {
    alert("Please enter a valid 10-digit phone number");
    return;
  }
  
  setPaymentProcessing(true);
  
  try {
    const isScriptLoaded = await loadRazorpayScript();
    if (!isScriptLoaded) {
      alert("Failed to load payment gateway. Please check your internet connection.");
      setPaymentProcessing(false);
      return;
    }
    
    const amountInRupees = selectedStall?.price || 8000;
    console.log("Creating order for amount (₹):", amountInRupees);
    
    const createOrderUrl = `${API_BASE_URL}/payments/create-order.php`;
    console.log("Calling:", createOrderUrl);
    
    const orderResponse = await axios.post(createOrderUrl, {
      amount: amountInRupees,  // Send in RUPEES
      currency: "INR",
      receipt: `stall_${selectedStall?.stallId || selectedStall?.number}_${Date.now()}`
    });
    
    console.log("Order response:", orderResponse.data);
    
    if (!orderResponse.data.success) {
      throw new Error(orderResponse.data.error || "Failed to create order");
    }
    
    const orderData = orderResponse.data;
    
    // The server returns amount in PAISE - use it directly
    console.log("Razorpay amount (in paise from server):", orderData.amount);
    
    const options = {
      key: "rzp_live_SlHZ4BKrM9xQKn",
      amount: orderData.amount,  // Use server-returned amount (already in paise)
      currency: orderData.currency || "INR",
      name: "Royal Heritage Fiesta",
      description: `Booking for Stall #${selectedStall?.stallId || selectedStall?.number}`,
      image: "https://royaleheritagefiesta.com/logo.png",
      order_id: orderData.orderId,
      handler: async function(response) {
        console.log("Payment success response:", response);
        await verifyAndCreateBooking(response, orderData.orderId);
      },
      prefill: {
        name: customer.name,
        email: customer.email,
        contact: customer.phone
      },
      notes: {
        eventId: eventId,
        stallNumber: selectedStall?.stallId || selectedStall?.number,
        eventName: event?.eventName
      },
      theme: {
        color: "#b8860b"
      },
      modal: {
        ondismiss: function() {
          console.log("Payment modal closed");
          setPaymentProcessing(false);
        }
      }
    };
    
    const rzp = new window.Razorpay(options);
    rzp.on('payment.failed', function(response) {
      console.error("Payment failed:", response.error);
      alert("Payment failed: " + (response.error.description || "Please try again"));
      setPaymentProcessing(false);
    });
    
    rzp.open();
    setShowPopup(false);
    
  } catch (error) {
    console.error("Payment initiation error:", error);
    console.error("Error details:", error.response?.data);
    alert(error.response?.data?.error || error.message || "Failed to initiate payment. Please try again.");
    setPaymentProcessing(false);
  }
};

  // Verify and Create Booking
  const verifyAndCreateBooking = async (paymentResponse, orderId) => {
    try {
      const verifyUrl = `${API_BASE_URL}/payments/verify-payment.php`;
      console.log("Verifying payment at:", verifyUrl);
      
      const verifyResponse = await axios.post(verifyUrl, {
        razorpay_order_id: paymentResponse.razorpay_order_id,
        razorpay_payment_id: paymentResponse.razorpay_payment_id,
        razorpay_signature: paymentResponse.razorpay_signature,
        orderId: orderId,
      });
      
      console.log("Verify response:", verifyResponse.data);
      
      if (!verifyResponse.data.success) {
        throw new Error(verifyResponse.data.error || "Payment verification failed");
      }
      
      // Prepare booking data
      const bookingData = {
        eventId: parseInt(eventId),
        stallNumber: selectedStall?.stallId || selectedStall?.number,
        stallPrice: selectedStall?.price || 8000,
        discount: 0,
        finalPrice: selectedStall?.price || 8000,
        paymentReceipt: null,
        paymentId: paymentResponse.razorpay_payment_id,
        orderId: paymentResponse.razorpay_order_id,
        eventName: event?.eventName,
        eventDate: event?.eventDate,
        eventPlace: event?.place,
        itemType: "Stall",
        itemNumber: selectedStall?.stallId || selectedStall?.number,
        bookingTime: new Date().toISOString().slice(0, 19).replace('T', ' '),
        customerName: customer.name,
        customerPhone: customer.phone,
        customerEmail: customer.email,
        customerCompany: customer.company || "",
        customerRequirements: customer.requirements || "",
        paymentMethod: "RAZORPAY",
        paymentStatus: "PAID",
        bookingStatus: "CONFIRMED"
      };
      
      console.log("Creating booking with data:", bookingData);
      
      const bookingResponse = await axios.post(`${API_BASE_URL}/stall-bookings.php`, bookingData);
      
      if (bookingResponse.data.success) {
        // Update local state
        if (isCustomLayout) {
          const updatedStalls = customStalls.map(s => 
            (s.number === selectedStall.number || s.stallId === selectedStall.stallId)
              ? { ...s, booked: true }
              : s
          );
          setCustomStalls(updatedStalls);
        } else {
          const updatedStalls = stalls.map(s => 
            s.stallId === selectedStall.stallId ? { ...s, booked: true } : s
          );
          setStalls(updatedStalls);
        }
        
        setStats(prev => ({
          ...prev,
          bookedCount: prev.bookedCount + 1,
          availableCount: prev.availableCount - 1
        }));
        
        // Prepare receipt data
        const receiptDataObj = {
          receiptId: bookingResponse.data.bookingId || `RHF-${Date.now()}`,
          paymentId: paymentResponse.razorpay_payment_id,
          orderId: paymentResponse.razorpay_order_id,
          amount: selectedStall?.price || 8000,
          bookingId: bookingResponse.data.bookingId,
          eventName: event?.eventName,
          eventDate: event?.eventDate,
          eventPlace: event?.place,
          itemType: "Stall",
          itemNumber: selectedStall?.stallId || selectedStall?.number,
          bookingTime: new Date().toISOString(),
          customer: {
            name: customer.name,
            phone: customer.phone,
            email: customer.email
          }
        };
        
        setReceiptData(receiptDataObj);
        setShowReceipt(true);
        
        // Send WhatsApp confirmation
        await sendAdminWhatsAppConfirmation(
          {
            bookingId: bookingResponse.data.bookingId,
            eventName: event?.eventName,
            eventDate: event?.eventDate,
            eventPlace: event?.place,
            stallNumber: selectedStall?.stallId || selectedStall?.number,
            amount: selectedStall?.price || 8000,
            bookingTime: new Date().toLocaleString()
          },
          {
            paymentId: paymentResponse.razorpay_payment_id,
            orderId: paymentResponse.razorpay_order_id
          },
          {
            name: customer.name,
            phone: customer.phone,
            email: customer.email,
            company: customer.company,
            requirements: customer.requirements
          }
        );
        
        // Send booking confirmation emails to BOTH customer and admin
        await sendBookingEmails(
          {
            bookingId: bookingResponse.data.bookingId,
            stallNumber: selectedStall?.stallId || selectedStall?.number,
            amount: selectedStall?.price || 8000,
            bookingTime: new Date().toLocaleString()
          },
          {
            paymentId: paymentResponse.razorpay_payment_id,
            orderId: paymentResponse.razorpay_order_id
          },
          {
            name: customer.name,
            phone: customer.phone,
            email: customer.email,
            company: customer.company,
            requirements: customer.requirements
          },
          {
            eventName: event?.eventName,
            eventDate: event?.eventDate,
            eventPlace: event?.place
          }
        );
        
        // Reset form
        setCustomer({
          name: "",
          phone: "",
          email: "",
          company: "",
          requirements: ""
        });
        setSelectedStall(null);
      } else {
        throw new Error(bookingResponse.data.message || "Booking creation failed");
      }
      
    } catch (error) {
      console.error("Booking creation error:", error);
      console.error("Error details:", error.response?.data);
      alert("Payment was successful but booking failed. Please contact support with your payment ID: " + (paymentResponse?.razorpay_payment_id || 'N/A'));
    } finally {
      setPaymentProcessing(false);
    }
  };

  const renderStallCard = (stall, position = '') => (
    <div 
      key={stall.stallId} 
      className={`stall-item ${position}`}
      onClick={() => !stall.booked && handleStallClick(stall)}
    >
      <div className={`stall-card ${stall.booked ? 'booked' : 'available'}`}>
        <div className="stall-number">{stall.stallId}</div>
        <div className="stall-price">₹{stall.price}</div>
      </div>
    </div>
  );

  const renderFixedElement = (el) => {
    if (!el) return null;
    return (
      <div
        key={el.id}
        className="fixed-element"
        style={{
          position: 'absolute',
          left: el.x,
          top: el.y,
          width: el.width,
          height: el.height,
          backgroundColor: el.color || '#e2e8f0',
          border: '1px solid #cbd5e0',
          borderRadius: '6px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '12px',
          color: '#1e293b',
          pointerEvents: 'none',
          zIndex: 15
        }}
      >
        <span>{el.icon || el.iconChar || '📍'}</span>
        <span style={{ marginLeft: '5px' }}>{el.label}</span>
      </div>
    );
  };

  const renderCustomStall = (stall) => {
    if (!stall) return null;
    
    const numberFontSize = Math.max(10, Math.min(18, (stall.width || 60) / 4));
    const priceFontSize = Math.max(8, Math.min(14, (stall.width || 60) / 5));
    const stallNumber = stall.number || stall.stallNumber || '?';
    const stallPrice = stall.price || 8000;
    const stallIcon = stall.icon || '';
    const stallColor = stall.booked ? '#fecaca' : '#dcfce7';
    const stallBorderColor = stall.booked ? '#ef4444' : '#22c55e';
    const isBooked = stall.booked || false;

    const x = parseFloat(stall.x) || 0;
    const y = parseFloat(stall.y) || 0;
    const width = parseFloat(stall.width) || 60;
    const height = parseFloat(stall.height) || 60;

    return (
      <div
        key={stall.id || `stall-${stallNumber}`}
        className={`custom-stall ${isBooked ? 'booked' : 'available'}`}
        onClick={() => !isBooked && handleCustomStallClick(stall)}
        onMouseEnter={() => setHoveredStall(stall)}
        onMouseLeave={() => setHoveredStall(null)}
        style={{
          position: 'absolute',
          left: `${x}px`,
          top: `${y}px`,
          width: `${width}px`,
          height: `${height}px`,
          backgroundColor: stallColor,
          border: `2px solid ${stallBorderColor}`,
          borderRadius: '8px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: isBooked ? 'not-allowed' : 'pointer',
          transition: 'all 0.2s',
          zIndex: 20,
          padding: '4px',
          textAlign: 'center',
          color: '#1e293b'
        }}
      >
        <div style={{ fontSize: `${numberFontSize}px`, fontWeight: '600', color: '#1e293b' }}>{stallNumber}</div>
        <div style={{ fontSize: `${priceFontSize}px`, color: '#1e293b' }}>₹{stallPrice}</div>
        <div style={{ fontSize: `${priceFontSize + 4}px`, color: '#1e293b' }}>{stallIcon}</div>
      </div>
    );
  };

  if (loading) {
    return (
      <>
        <Navbar />
        <div className="booking-loading-container">
          <div className="booking-loader"></div>
          <p>Loading stalls layout...</p>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <Navbar />
        <div className="booking-error-container">
          <div className="booking-error-card">
            <span className="booking-error-icon">⚠️</span>
            <h3>Oops! Something went wrong</h3>
            <p>{error}</p>
            <button className="booking-retry-btn" onClick={() => window.location.reload()}>
              Try Again
            </button>
          </div>
        </div>
      </>
    );
  }

  const positionedStalls = getStallsByPosition();

  return (
    <>
      <Navbar />
      <div className="booking-page">
        <div className="booking-container">
          
          {/* Event Header */}
          <div className="booking-header">
            <h1 className="booking-title">{event?.eventName || 'Event'} - Floor Plan</h1>
            <div className="booking-stats">
              <div className="stat-card">
                <span className="stat-label">Total Stalls</span>
                <span style={{color:"green",fontSize:"1.1rem",fontWeight: "700"}}>{stats.totalStalls}</span>
              </div>
              <div className="stat-card">
                <span className="stat-label">Available</span>
                <span style={{color:"green",fontSize:"1.1rem",fontWeight: "700"}}>{stats.availableCount}</span>
              </div>
              <div className="stat-card">
                <span className="stat-label">Booked</span>
                <span style={{color:"red",fontSize:"1.1rem",fontWeight: "700"}}>{stats.bookedCount}</span>
              </div>
            </div>
          </div>

          {/* Layout Info */}
          <div className="layout-info">
            <div className="layout-badge">
              <span className="layout-icon">
                {isCustomLayout ? '🎨' : 
                  stallPattern === 'full' ? '▦' : 
                  stallPattern === 'ushape' ? '⊔' : '‖'}
              </span>
              <span>
                {isCustomLayout ? 'CUSTOM LAYOUT' : 
                  stallPattern === 'full' ? 'RECTANGULAR LAYOUT' : 
                  stallPattern === 'ushape' ? 'U-SHAPE LAYOUT' : 'TWO-SIDES LAYOUT'}
              </span>
            </div>
            <div className="layout-legend">
              <div className="legend-item">
                <span className="legend-dot available"></span>
                <span>Available</span>
              </div>
              <div className="legend-item">
                <span className="legend-dot booked"></span>
                <span>Booked</span>
              </div>
            </div>
            {isCustomLayout && backgroundImage && (
              <label className="blueprint-toggle">
                <input 
                  type="checkbox" 
                  checked={showBlueprint}
                  onChange={(e) => setShowBlueprint(e.target.checked)}
                />
                Show Blueprint
              </label>
            )}
          </div>

          {/* Zoom Controls for Mobile */}
          <div className="zoom-controls">
            <button className="zoom-btn" onClick={handleZoomOut} title="Zoom Out">
              <span>−</span>
            </button>
            <span className="zoom-level">{Math.round(zoomLevel * 100)}%</span>
            <button className="zoom-btn" onClick={handleZoomIn} title="Zoom In">
              <span>+</span>
            </button>
            <button className="zoom-btn reset" onClick={handleResetZoom} title="Reset Zoom">
              <span>⟳</span>
            </button>
          </div>

          {/* Blueprint Container */}
          <div className="blueprint-container">
            
            {!isCustomLayout && (
              <div className="map-elements-container">
                {event?.showEntrance && (
                  <div className="map-element entrance north">
                    <div className="map-icon">🚪</div>
                    <div className="map-label">ENTRANCE</div>
                  </div>
                )}
                {event?.showExit && (
                  <div className="map-element exit south">
                    <div className="map-icon">🚪</div>
                    <div className="map-label">EXIT</div>
                  </div>
                )}
                {event?.showStage && (
                  <div className="map-element stage">
                    <div className="map-icon">🎪</div>
                    <div className="map-label">STAGE</div>
                  </div>
                )}
                {event?.showParking && (
                  <div className="map-element parking">
                    <div className="map-icon">🅿️</div>
                    <div className="map-label">PARKING</div>
                  </div>
                )}
                {event?.showFoodCourt && (
                  <div className="map-element food-court">
                    <div className="map-icon">🍔</div>
                    <div className="map-label">FOOD COURT</div>
                  </div>
                )}
                {event?.showRestrooms && (
                  <div className="map-element restrooms">
                    <div className="map-icon">🚻</div>
                    <div className="map-label">RESTROOMS</div>
                  </div>
                )}
                {event?.showFirstAid && (
                  <div className="map-element first-aid">
                    <div className="map-icon">🏥</div>
                    <div className="map-label">FIRST AID</div>
                  </div>
                )}
              </div>
            )}

            {isCustomLayout ? (
              <div 
                className="custom-layout-container"
                style={{ 
                  width: '100%',
                  maxWidth: imageDimensions.width,
                  height: 'auto',
                  position: 'relative',
                  background: '#f8fafc',
                  borderRadius: '12px',
                  overflow: 'auto',
                  border: '1px solid #e2e8f0',
                  margin: '20px auto'
                }}
              >
                <div 
                  style={{
                    position: 'relative',
                    width: imageDimensions.width,
                    height: imageDimensions.height,
                    margin: '0 auto',
                    transform: `scale(${zoomLevel})`,
                    transformOrigin: 'center top',
                    transition: 'transform 0.2s ease'
                  }}
                >
                  {backgroundImage && showBlueprint && (
                    <img 
                      src={backgroundImage} 
                      alt="Venue Blueprint"
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        opacity: imageOpacity,
                        objectFit: 'fill',
                        pointerEvents: 'none'
                      }}
                    />
                  )}
                  <div 
                    className="blueprint-grid"
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      backgroundImage: 'linear-gradient(to right, rgba(0,0,0,0.05) 1px, transparent 1px), linear-gradient(to bottom, rgba(0,0,0,0.05) 1px, transparent 1px)',
                      backgroundSize: `${gridSize}px ${gridSize}px`,
                      pointerEvents: 'none',
                      zIndex: 2
                    }}
                  />
                  {fixedElements && fixedElements.map(el => renderFixedElement(el))}
                  <div className="custom-stalls-container" style={{ position: 'relative', width: '100%', height: '100%' }}>
                    {customStalls && customStalls.length > 0 ? (
                      customStalls.map(stall => renderCustomStall(stall))
                    ) : (
                      <div className="no-stalls-message">No stalls found in this layout</div>
                    )}
                  </div>
                  <div className="directional north">NORTH</div>
                  <div className="directional south">SOUTH</div>
                  <div className="directional east">EAST</div>
                  <div className="directional west">WEST</div>
                </div>
              </div>
            ) : (
              <div style={{ transform: `scale(${zoomLevel})`, transformOrigin: 'center top', transition: 'transform 0.2s ease' }}>
                {stallPattern === 'full' && (
                  <div className="layout full">
                    <div className="row top">
                      <div className="row-label">NORTH WING</div>
                      <div className="stalls-row">
                        {positionedStalls.top.map(stall => renderStallCard(stall, 'top'))}
                      </div>
                    </div>
                    <div className="middle-section">
                      <div className="column left">
                        <div className="column-label">WEST WING</div>
                        <div className="stalls-column">
                          {positionedStalls.left.map(stall => renderStallCard(stall, 'left'))}
                        </div>
                      </div>
                      <div className="central-area">
                        <div className="central-content">
                          <div className="compass">
                            <div className="compass-north">N</div>
                            <div className="compass-east">E</div>
                            <div className="compass-south">S</div>
                            <div className="compass-west">W</div>
                          </div>
                          <h3>EXHIBITION HALL</h3>
                          <p>Main Arena</p>
                          <div className="central-amenities">
                            {event?.showFoodCourt && <span className="amenity">🍔 Food Court</span>}
                            {event?.showRestrooms && <span className="amenity">🚻 Restrooms</span>}
                            {event?.showFirstAid && <span className="amenity">🏥 First Aid</span>}
                          </div>
                        </div>
                      </div>
                      <div className="column right">
                        <div className="column-label">EAST WING</div>
                        <div className="stalls-column">
                          {positionedStalls.right.map(stall => renderStallCard(stall, 'right'))}
                        </div>
                      </div>
                    </div>
                    <div className="row bottom">
                      <div className="row-label">SOUTH WING</div>
                      <div className="stalls-row">
                        {positionedStalls.bottom.map(stall => renderStallCard(stall, 'bottom'))}
                      </div>
                    </div>
                  </div>
                )}

                {stallPattern === 'ushape' && (
                  <div className="layout ushape">
                    <div className="open-top">
                      <span className="open-top-label">OPEN CONCOURSE</span>
                    </div>
                    <div className="outer-u">
                      <div className="wing left">
                        <div className="wing-label">WEST WING</div>
                        <div className="stalls-column">
                          {positionedStalls.left.map(stall => renderStallCard(stall, 'left'))}
                        </div>
                      </div>
                      <div className="performance-area">
                        {event?.showStage && (
                          <div className="stage-platform">
                            <span className="stage-icon">🎪</span>
                            <span>MAIN STAGE</span>
                          </div>
                        )}
                        <div className="performance-space">
                          <h3>PERFORMANCE ARENA</h3>
                          <div className="inner-u">
                            <div className="inner-left">
                              <div className="inner-label">PREMIUM LEFT</div>
                              <div className="stalls-row-inner">
                                {positionedStalls.leftInner.map(stall => renderStallCard(stall, 'inner'))}
                              </div>
                            </div>
                            <div className="inner-center">
                              <span>VIP LOUNGE</span>
                            </div>
                            <div className="inner-right">
                              <div className="inner-label">PREMIUM RIGHT</div>
                              <div className="stalls-row-inner">
                                {positionedStalls.rightInner.map(stall => renderStallCard(stall, 'inner'))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="wing right">
                        <div className="wing-label">EAST WING</div>
                        <div className="stalls-column">
                          {positionedStalls.right.map(stall => renderStallCard(stall, 'right'))}
                        </div>
                      </div>
                    </div>
                    <div className="bottom-wing">
                      <div className="wing-label">SOUTH WING</div>
                      <div className="stalls-row-bottom">
                        {positionedStalls.bottom.map(stall => renderStallCard(stall, 'bottom'))}
                      </div>
                    </div>
                  </div>
                )}

                {stallPattern === 'twosides' && (
                  <div className="layout twosides">
                    <div className="main-aisle">
                      <div className="sides-container">
                        <div className="side left">
                          <div className="side-label">BAZAAR - WEST</div>
                          <div className="stalls-grid-left">
                            {positionedStalls.left.map(stall => renderStallCard(stall))}
                          </div>
                        </div>
                        <div className="walkway">
                          <div className="walkway-content">
                            <span>MAIN WALKWAY</span>
                          </div>
                          {event?.showFoodCourt && <div className="walkway-amenity food">🍔 Food Court</div>}
                          {event?.showRestrooms && <div className="walkway-amenity rest">🚻 Restrooms</div>}
                        </div>
                        <div className="side right">
                          <div className="side-label">BAZAAR - EAST</div>
                          <div className="stalls-grid-right">
                            {positionedStalls.right.map(stall => renderStallCard(stall))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="directional north">NORTH</div>
                <div className="directional south">SOUTH</div>
                <div className="directional east">EAST</div>
                <div className="directional west">WEST</div>
              </div>
            )}
          </div>

          <div className="booking-legend">
            <div className="legend-item">
              <span className="legend-dot available"></span>
              <span>Available - Click to book</span>
            </div>
            <div className="legend-item">
              <span className="legend-dot booked"></span>
              <span>Already Booked</span>
            </div>
          </div>
        </div>
      </div>

      {/* Booking Popup */}
      {showPopup && selectedStall && (
        <div className="modal-overlay" onClick={() => setShowPopup(false)}>
          <div className="booking-modal" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowPopup(false)}>×</button>
            <div className="modal-header">
              <div className="modal-header-icon">🛍️</div>
              <h3 className="modal-title">Book Stall {selectedStall.stallId}</h3>
              <div className="modal-price">₹{selectedStall.price}</div>
              <p className="modal-subtitle">Fill your details to proceed</p>
            </div>
            <div className="modal-body">
              <div className="form-group">
                <label>Full Name <span className="required">*</span></label>
                <input
                  type="text"
                  placeholder="Enter your full name"
                  value={customer.name}
                  onChange={e => setCustomer({...customer, name: e.target.value})}
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label>Phone Number <span className="required">*</span></label>
                <input
                  type="tel"
                  placeholder="10-digit mobile number"
                  value={customer.phone}
                  onChange={e => setCustomer({...customer, phone: e.target.value})}
                  maxLength="10"
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label>Email Address <span className="required">*</span></label>
                <input
                  type="email"
                  placeholder="your@email.com"
                  value={customer.email}
                  onChange={e => setCustomer({...customer, email: e.target.value})}
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label>Company Name (Optional)</label>
                <input
                  type="text"
                  placeholder="Enter your company name"
                  value={customer.company}
                  onChange={e => setCustomer({...customer, company: e.target.value})}
                  className="modern-input"
                />
              </div>
              <div className="form-group">
                <label>Special Requirements (Optional)</label>
                <textarea
                  placeholder="Any specific requirements for this stall..."
                  value={customer.requirements}
                  onChange={e => setCustomer({...customer, requirements: e.target.value})}
                  className="modern-input"
                  rows="3"
                />
              </div>
              <div className="info-box">
                <div className="info-icon">📸</div>
                <div className="info-text">
                  <strong>Need help?</strong> Click "Assistance" to chat with our team.<br/>
                  <strong>Ready to book?</strong> Click "Proceed to Pay" to complete your booking.
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button 
                className="modal-btn cancel-btn"
                onClick={() => {
                  setShowPopup(false);
                  setCustomer({ name: "", phone: "", email: "", company: "", requirements: "" });
                }}
              >
                Cancel
              </button>
              <button 
                className="modal-btn assistance-btn"
                onClick={handleWhatsAppAssistance}
                disabled={paymentProcessing}
              >
                <span className="btn-icon">💬</span> Assistance
              </button>
              <button 
                className="modal-btn payment-btn"
                onClick={handleProceedToPay}
                disabled={paymentProcessing}
              >
                {paymentProcessing ? (
                  <span className="btn-spinner"></span>
                ) : (
                  <>
                    <span className="btn-icon">💳</span> Pay ₹{selectedStall.price}
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Payment Receipt Modal */}
      <PaymentReceipt 
        isOpen={showReceipt} 
        onClose={() => setShowReceipt(false)} 
        bookingDetails={receiptData} 
      />
      
      <Footer />

      {/* Floating Buttons */}
      <div className={`floating-buttons ${showFloatingButtons ? 'show' : ''}`}>
        <button className="floating-btn whatsapp" onClick={handleWhatsAppClick}>
          <i className="bi bi-whatsapp"></i>
        </button>
        <button className="floating-btn top" onClick={handleBackToTop}>
          <i className="bi bi-arrow-up"></i>
        </button>
      </div>
      <div className={`back-to-top ${showBackToTop ? 'show' : ''}`} onClick={handleBackToTop}>
        <i className="bi bi-arrow-up"></i>
      </div>

      <style jsx>{`
        .booking-page {
          background: #f5f5f5;
          max-width: 1400px;
          border-left: 29.5px solid #000;
          border-right: 29.5px solid #000;
          border-radius: 0;
          min-height: calc(100vh - 200px);
        }
        
        .booking-container {
          max-width: 1200px;
          margin: 0 auto;
          background: #ffffff;
          border-radius: 20px;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
          overflow: hidden;
          border: 1px solid #e2e8f0;
        }
        
        .booking-header {
          padding: 1.5rem;
          border-bottom: 1px solid #e2e8f0;
        }
        
        .booking-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 1rem;
          font-family: 'Cinzel', serif;
        }
        
        .booking-stats {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
        }
        
        .stat-card {
          background: #f8fafc;
          padding: 0.8rem 1.2rem;
          border-radius: 12px;
          border: 1px solid #e2e8f0;
        }
        
        .stat-label {
          display: block;
          font-size: 0.7rem;
          color: #141515 !important;
          margin-bottom: 0.2rem;
        }
        
        .layout-info {
          padding: 1rem 1.5rem;
          background: #f8fafc;
          border-bottom: 1px solid #e2e8f0;
          display: flex;
          align-items: center;
          gap: 1rem;
          flex-wrap: wrap;
        }
        
        .layout-badge {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.4rem 1rem;
          background: #ffffff;
          border-radius: 30px;
          border: 1px solid #e2e8f0;
          font-size: 0.8rem;
          font-weight: 600;
          color: #1e293b !important;
        }
        
        .layout-legend {
          display: flex;
          gap: 1rem;
        }
        
        .legend-item {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.75rem;
          color: #475569;
        }
        
        .legend-dot {
          width: 12px;
          height: 12px;
          border-radius: 3px;
        }
        
        .legend-dot.available { background: #dcfce7; border: 1px solid #22c55e; }
        .legend-dot.booked { background: #fecaca; border: 1px solid #ef4444; }
        
        .blueprint-toggle {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.75rem;
          color: #475569;
          cursor: pointer;
          margin-left: auto;
        }
        
        .blueprint-container {
          padding: 1.5rem;
          position: relative;
          overflow-x: auto;
        }
        
        .zoom-controls {
          display: none;
          justify-content: center;
          align-items: center;
          gap: 12px;
          padding: 10px;
          background: #f8fafc;
          border-bottom: 1px solid #e2e8f0;
        }
        
        .zoom-btn {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          border: 1px solid #e2e8f0;
          background: white;
          font-size: 20px;
          font-weight: bold;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s;
          color: #1e293b;
        }
        
        .zoom-btn:hover {
          background: #e2e8f0;
          transform: scale(1.05);
        }
        
        .zoom-btn.reset {
          font-size: 18px;
        }
        
        .zoom-level {
          font-size: 14px;
          font-weight: 600;
          color: #1e293b;
          min-width: 50px;
          text-align: center;
        }
        
        .stall-card {
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          padding: 0.5rem;
          text-align: center;
          transition: all 0.2s;
          cursor: pointer;
          min-width: 60px;
        }
        
        .stall-card .stall-number {
          font-size: 0.9rem;
          font-weight: 700;
          color: #1e293b;
        }
        
        .stall-card .stall-price {
          font-size: 0.7rem;
          color: #64748b;
          margin-top: 2px;
        }
        
        .stall-card.available:hover {
          transform: translateY(-2px);
          border-color: #22c55e;
          box-shadow: 0 2px 8px rgba(34, 197, 94, 0.1);
        }
        
        .stall-card.booked {
          background: #fef2f2;
          border-color: #fecaca;
          cursor: not-allowed;
          opacity: 0.7;
        }
        
        .layout {
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 16px;
          padding: 1.5rem;
          position: relative;
        }
        
        .stalls-row {
          display: flex;
          gap: 0.8rem;
          justify-content: center;
          flex-wrap: wrap;
        }
        
        .middle-section {
          display: flex;
          gap: 1rem;
          margin: 1rem 0;
        }
        
        .column {
          flex: 1;
        }
        
        .stalls-column {
          display: flex;
          flex-direction: column;
          gap: 0.8rem;
        }
        
        .central-area {
          flex: 2;
          background: #f8fafc;
          border-radius: 12px;
          padding: 1rem;
          text-align: center;
          border: 1px solid #e2e8f0;
        }
        
        .central-content h3 {
          font-size: 1rem;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 0.3rem;
        }
        
        .central-content p {
          font-size: 0.7rem;
          color: #64748b;
        }
        
        .central-amenities {
          display: flex;
          justify-content: center;
          gap: 1rem;
          margin-top: 0.8rem;
        }
        
        .amenity {
          font-size: 0.7rem;
          color: #475569;
        }
        
        .row-label, .column-label {
          font-size: 0.7rem;
          font-weight: 600;
          color: #64748b;
          margin-bottom: 0.5rem;
          text-align: center;
        }
        
        .directional {
          position: absolute;
          font-size: 0.7rem;
          color: #94a3b8;
          font-weight: 500;
        }
        
        .directional.north { top: 5px; left: 50%; transform: translateX(-50%); }
        .directional.south { bottom: 5px; left: 50%; transform: translateX(-50%); }
        .directional.east { right: 5px; top: 50%; transform: translateY(-50%); }
        .directional.west { left: 5px; top: 50%; transform: translateY(-50%); }
        
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.6);
          backdrop-filter: blur(4px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
          padding: 1rem;
        }
        
        .booking-modal {
          background: white;
          border-radius: 28px;
          max-width: 500px;
          width: 100%;
          max-height: 90vh;
          overflow-y: auto;
          position: relative;
          box-shadow: 0 20px 35px -10px rgba(0, 0, 0, 0.25);
          animation: modalSlideUp 0.3s ease;
        }
        
        @keyframes modalSlideUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .modal-close {
          position: absolute;
          top: 16px;
          right: 20px;
          background: rgba(0, 0, 0, 0.05);
          border: none;
          font-size: 22px;
          cursor: pointer;
          color: #64748b;
          z-index: 10;
          width: 34px;
          height: 34px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s;
        }
        
        .modal-close:hover {
          background: rgba(0, 0, 0, 0.1);
          color: #1e293b;
        }
        
        .modal-header {
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          padding: 1.5rem;
          text-align: center;
          border-bottom: 1px solid #e2e8f0;
          border-radius: 28px 28px 0 0;
        }
        
        .modal-header-icon {
          font-size: 44px;
          margin-bottom: 8px;
        }
        
        .modal-title {
          font-size: 1.35rem;
          font-weight: 700;
          color: #1e293b;
          margin: 0 0 4px;
          font-family: 'Cinzel', serif;
        }
        
        .modal-price {
          font-size: 1.6rem;
          font-weight: 800;
          color: #22c55e;
          margin: 6px 0;
          letter-spacing: -0.5px;
        }
        
        .modal-subtitle {
          font-size: 0.75rem;
          color: #64748b;
          margin: 0;
        }
        
        .modal-body {
          padding: 1.5rem;
        }
        
        .form-group {
          margin-bottom: 1rem;
        }
        
        .form-group label {
          display: block;
          font-size: 0.8rem;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 0.4rem;
        }
        
        .required {
          color: #ef4444;
        }
        
        .modern-input {
          width: 100%;
          padding: 0.75rem 1rem;
          border: 1.5px solid #e2e8f0;
          border-radius: 14px;
          font-size: 0.85rem;
          transition: all 0.2s;
          color: #1e293b;
          background: #ffffff;
        }
        
        .modern-input:focus {
          outline: none;
          border-color: #b8860b;
          box-shadow: 0 0 0 3px rgba(184, 134, 11, 0.1);
        }
        
        textarea.modern-input {
          resize: vertical;
          min-height: 70px;
        }
        
        .info-box {
          background: #fef9e3;
          border-radius: 14px;
          padding: 12px 14px;
          display: flex;
          gap: 12px;
          margin-top: 1rem;
          border-left: 4px solid #b8860b;
        }
        
        .info-icon {
          font-size: 20px;
        }
        
        .info-text {
          font-size: 0.75rem;
          color: #92400e;
          line-height: 1.4;
        }
        
        /* ========== MODAL FOOTER BUTTONS - RESTYLED ========== */
        .modal-footer {
          padding: 0 1.5rem 1.8rem;
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
        }
        
        .modal-btn {
          flex: 1;
          padding: 12px 16px;
          border: none;
          border-radius: 50px;
          font-weight: 600;
          font-size: 0.9rem;
          cursor: pointer;
          transition: all 0.25s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          min-width: 110px;
        }
        
        .modal-btn .btn-icon {
          font-size: 1rem;
        }
        
        /* Cancel Button */
        .cancel-btn {
          background: #f1f5f9;
          color: #475569;
          border: 1px solid #e2e8f0;
        }
        
        .cancel-btn:hover {
          background: #e2e8f0;
          color: #1e293b;
          transform: translateY(-2px);
        }
        
        /* Need Help / Assistance Button */
        .assistance-btn {
          background: #25D366;
          color: white;
          box-shadow: 0 2px 8px rgba(37, 211, 102, 0.3);
        }
        
        .assistance-btn:hover {
          background: #20b859;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
        }
        
        /* Proceed to Pay Button */
        .payment-btn {
          background: linear-gradient(135deg, #b8860b 0%, #9a6b06 100%);
          color: white;
          box-shadow: 0 2px 8px rgba(184, 134, 11, 0.3);
        }
        
        .payment-btn:hover {
          background: linear-gradient(135deg, #9a6b06 0%, #7a5205 100%);
          transform: translateY(-2px);
          box-shadow: 0 4px 14px rgba(184, 134, 11, 0.4);
        }
        
        .modal-btn:active {
          transform: translateY(0);
        }
        
        .modal-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }
        
        /* Loading Spinner for Payment Button */
        .btn-spinner {
          width: 18px;
          height: 18px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-top-color: white;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }
        
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        
        /* ========== RESPONSIVE MOBILE STYLES ========== */
        @media (max-width: 550px) {
          .modal-footer {
            flex-direction: row;
            flex-wrap: wrap;
            gap: 8px;
            padding: 0 1rem 1.2rem;
          }
          
          .modal-btn {
            flex: 1;
            min-width: 0;
            padding: 10px 8px;
            font-size: 0.75rem;
            gap: 4px;
            border-radius: 40px;
          }
          
          .modal-btn .btn-icon {
            font-size: 0.85rem;
          }
          
          /* Make buttons smaller and compact on mobile */
          .cancel-btn {
            order: 1;
            flex: 0.8;
          }
          
          .assistance-btn {
            order: 2;
            flex: 1;
          }
          
          .payment-btn {
            order: 3;
            flex: 1.2;
          }
          
          .booking-modal {
            max-width: 95%;
            border-radius: 24px;
          }
          
          .modal-header {
            padding: 1rem;
          }
          
          .modal-header-icon {
            font-size: 32px;
          }
          
          .modal-title {
            font-size: 1.1rem;
          }
          
          .modal-price {
            font-size: 1.3rem;
          }
          
          .modal-body {
            padding: 1rem;
          }
          
          .form-group {
            margin-bottom: 0.8rem;
          }
          
          .modern-input {
            padding: 0.6rem 0.8rem;
            font-size: 0.8rem;
          }
          
          .info-box {
            padding: 8px 10px;
            margin-top: 0.8rem;
          }
          
          .info-text {
            font-size: 0.7rem;
          }
          
          .info-icon {
            font-size: 16px;
          }
        }
        
        /* Extra small devices */
        @media (max-width: 380px) {
          .modal-footer {
            gap: 6px;
            padding: 0 0.8rem 1rem;
          }
          
          .modal-btn {
            padding: 8px 6px;
            font-size: 0.7rem;
          }
          
          .modal-btn .btn-icon {
            font-size: 0.75rem;
          }
          
          .cancel-btn {
            flex: 0.7;
          }
          
          .assistance-btn {
            flex: 1;
          }
          
          .payment-btn {
            flex: 1.1;
          }
        }
        
        /* Desktop hover effects */
        @media (min-width: 551px) {
          .modal-btn {
            transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          }
        }
        
        .booking-legend {
          padding: 1rem 1.5rem;
          border-top: 1px solid #e2e8f0;
          display: flex;
          justify-content: center;
          gap: 2rem;
          background: #f8fafc;
        }
        
        .booking-loading-container, .booking-error-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f5f5f5;
          margin: 0 auto;
          width: 98%;
          max-width: 1400px;
          border-left: 11px solid #000;
          border-right: 11px solid #000;
        }
        
        .booking-loader {
          width: 40px;
          height: 40px;
          border: 3px solid #e2e8f0;
          border-top-color: #22c55e;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin-bottom: 1rem;
        }
        
        .booking-error-card {
          background: white;
          padding: 2rem;
          border-radius: 20px;
          text-align: center;
          max-width: 400px;
          border: 1px solid #e2e8f0;
        }
        
        .booking-error-icon {
          font-size: 40px;
          display: block;
          margin-bottom: 1rem;
        }
        
        .booking-retry-btn {
          margin-top: 1rem;
          padding: 0.6rem 1.5rem;
          background: #22c55e;
          color: white;
          border: none;
          border-radius: 30px;
          cursor: pointer;
          font-weight: 600;
        }
        
        .floating-buttons {
          position: fixed;
          bottom: 20px;
          right: 20px;
          display: flex;
          flex-direction: column;
          gap: 10px;
          z-index: 1000;
          opacity: 0;
          visibility: hidden;
          transform: translateY(20px);
          transition: 0.3s;
        }
        
        .floating-buttons.show {
          opacity: 1;
          visibility: visible;
          transform: translateY(0);
        }
        
        .floating-btn {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          border: none;
          cursor: pointer;
          transition: 0.3s;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          color: #fff;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        }
        
        .floating-btn.whatsapp {
          background: #25d366;
        }
        
        .floating-btn.top {
          background: #1e293b;
        }
        
        .floating-btn:hover {
          transform: scale(1.1);
        }
        
        .back-to-top {
          position: fixed;
          bottom: 20px;
          right: 20px;
          width: 45px;
          height: 45px;
          background: #1e293b;
          color: #fff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          opacity: 0;
          visibility: hidden;
          transition: 0.2s;
          z-index: 99;
          border: none;
        }
        
        .back-to-top.show {
          opacity: 1;
          visibility: visible;
        }
        
        .back-to-top:hover {
          background: #334155;
          transform: translateY(-3px);
        }
        
        @media (max-width: 992px) {
          .booking-page {
            border-left: 19.5px solid #000;
            border-right: 19.5px solid #000;
          }
          .zoom-controls {
            display: flex;
          }
        }
        
        @media (max-width: 768px) {
          .booking-page { 
            padding: 0; 
            width: 100%; 
            border-left: 14px solid #000 !important;
            border-right: 14px solid #000 !important;
            box-sizing: border-box;
          }
          .booking-header { padding: 1rem; }
          .booking-title { font-size: 1.2rem; }
          .layout-info { flex-direction: column; align-items: flex-start; }
          .blueprint-toggle { margin-left: 0; }
          .middle-section { flex-direction: column; }
          .stalls-row { gap: 0.5rem; }
          .stall-card { padding: 0.4rem; min-width: 50px; }
          .stall-number { font-size: 0.75rem; }
          .zoom-controls { gap: 8px; }
          .zoom-btn { width: 36px; height: 36px; font-size: 18px; }
          .zoom-level { font-size: 12px; min-width: 45px; }
        }
        
        @media (max-width: 480px) {
          .booking-page {
            border-left: 17.5px solid #000 !important;
            border-right: 17.5px solid #000 !important;
          }
          .zoom-btn { width: 32px; height: 32px; font-size: 16px; }
          .zoom-level { font-size: 11px; min-width: 40px; }
        }
      `}</style>
    </>
  );
}

export default Booking_event;